import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import GraphHeader from "./GraphHeader";
import { formatOutput } from "../../utils/computation/analysis";

const ImageGraph = ({
	url,
	title,
	column,
	percent,
	dateTime,
	x,
	y,
	firstColumn,
	secondColumn,
	percetageURL,
	analysisId,
	confidenceLevel,
	meanHypothesis,
	selectedColors,
	isFit,
	pearson,
	withReg,
	url2,
}) => {
	const [open, setOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState("");

	const handleClickOpen = (imgUrl) => {
		setSelectedImage(imgUrl);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		setSelectedImage("");
	};

	const handleDownload = () => {
		const link = document.createElement("a");
		link.href = selectedImage;
		link.download = "tuos_image_download.png";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	let imgUrl = "data:image/png;base64," + url;
	let imgUrl2 = url2 ? "data:image/png;base64," + url2 : false;
	let percentageImgURL = "data:image/png;base64," + percetageURL;
	let header =
		title !== ""
			? title === "Time Series"
				? "Time series for " + x + " x " + y
				: title + " of Column " + column
			: "";
	// let subHeader = "(with " + percent + "% t-confidence interval for the mean)";

	let note = "x-axis: " + x + " , y-axis: " + y;

	const handleAdditionals = () => {
		if (title === "Time Series") {
			return { x, y };
		}
		if (title === "1-Sample t") {
			return { confidenceLevel, meanHypothesis };
		}
		if (title === "Simple Histogram") {
			return { isFit };
		}
		if (title === "Multi Variable Histogram") {
			return { selectedColors, isFit };
		}
		if (title === "Simple Scatterplot") {
			return { x, y, withReg };
		}
		return null;
	};

	return (
		<Container>
			{percent === "GraphOnly" && (
				<GraphHeader
					column={column}
					dateTime={dateTime}
					title={title}
					firstColumn={firstColumn}
					secondColumn={secondColumn}
					analysisId={analysisId}
					additionals={handleAdditionals()}
				/>
			)}
			<Grid container spacing={0} direction="column" alignItems="center" justify="center">
				<Grid item xs={3} sx={{ mt: 3 }}>
					{header}
				</Grid>
				{/* {percent === "GraphOnly" || (
          <Grid item xs={3}>
            {subHeader}
          </Grid>
        )} */}
			</Grid>
			{/* Graph here */}
			<Grid container spacing={0} direction="column" alignItems="center" justify="center">
				<Grid item xs={3}>
					<Box
						component="img"
						sx={{
							height: 300,
							width: 400,
							maxHeight: { xs: 500, md: 500 },
							maxWidth: { xs: 500, md: 500 },
							cursor: "pointer",
						}}
						alt="Graph"
						src={imgUrl}
						onClick={() => handleClickOpen(imgUrl)}
					/>
				</Grid>
				{percetageURL && (
					<Grid item xs={3}>
						<Box
							component="img"
							sx={{
								height: 300,
								width: 400,
								maxHeight: { xs: 500, md: 500 },
								maxWidth: { xs: 500, md: 500 },
								cursor: "pointer",
							}}
							alt="Graph"
							src={percentageImgURL}
							onClick={() => handleClickOpen(percentageImgURL)}
						/>
					</Grid>
				)}

				{imgUrl2 && (
					<Grid item xs={3}>
						<Box
							component="img"
							sx={{
								height: 300,
								width: 400,
								maxHeight: { xs: 500, md: 500 },
								maxWidth: { xs: 500, md: 500 },
								cursor: "pointer",
							}}
							alt="Graph"
							src={imgUrl2}
							onClick={() => handleClickOpen(imgUrl2)}
						/>
					</Grid>
				)}
				{title === "Time Series" && note}
			</Grid>

			{title === "Simple Scatterplot" && (
				<Grid container spacing={0} direction="column" alignItems="center" justify="center">
					<Grid item xs={3} sx={{ display: "flex", gap: 2 }}>
						<h4 style={{ fontWeight: "bolder" }}>Pearson's r: {formatOutput(pearson.r)}</h4>
						<h4 style={{ fontWeight: "bolder" }}>p-value: {formatOutput(pearson.pValue)}</h4>
					</Grid>
				</Grid>
			)}

			<Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
				<DialogContent sx={{ position: "relative" }}>
					<IconButton
						onClick={handleDownload}
						sx={{
							position: "absolute",
							top: 8,
							right: 8,
							color: "lightGrey",
						}}>
						<DownloadIcon />
					</IconButton>
					<img src={selectedImage} alt="Large Graph" style={{ width: "100%", height: "auto" }} />
				</DialogContent>
			</Dialog>
		</Container>
	);
};

export default ImageGraph;
